import { InputField } from "./InputField";

import type { InputFieldPropsBase } from "./InputField";
import type { KeyboardEvent } from "react";

const onEmailInputFieldKeyPress = (e: KeyboardEvent<HTMLInputElement>) => {
	// Hack.
	// See https://bokiodev.visualstudio.com/Voder/_workitems/edit/6525
	// and https://github.com/facebook/react/issues/6368.
	if (/\s/.test(e.key)) {
		e.preventDefault();
	}
};

type ChangeHandler = (v: string) => void;

const removeWhiteSpaces = (onChange: ChangeHandler | undefined): ChangeHandler | undefined =>
	onChange ? val => onChange(val ? val.replace(/\s/g, "") : "") : undefined;

type EmailFieldProps = InputFieldPropsBase;

export const EmailField = (props: EmailFieldProps) => (
	<InputField
		{...{
			...props,
			onChange: removeWhiteSpaces(props.onChange),
			fieldProps: {
				...props.fieldProps,
				type: "email",
				onKeyPress: onEmailInputFieldKeyPress,
			},
		}}
	/>
);
